export default __webpack_public_path__ + "static/media/HASSAN_NL_SEQ12.199180ec.mp3";